<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Cash movements</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (cash_movements && cash_movements.length != 0) {
    <ion-list>
      @for (cash_movement of cash_movements; track cash_movement) {
        <ion-item lines="full">
          <ion-label>
            <h3>{{cash_movement.user_first_name}} {{cash_movement.user_last_name}}</h3>
            <ion-grid class="ion-no-padding">
              <ion-row>
                <ion-col size="auto">
                  <h5>Date</h5>
                  <p class="prominent">{{moment(cash_movement.date).format("D MMM YYYY")}}</p>
                </ion-col>
                <ion-col size="auto">
                  <h5>Time</h5>
                  <p class="prominent">{{moment(cash_movement.date).format("HH:mm")}}</p>
                </ion-col>
                <ion-col size="auto">
                  <h5>Amount</h5>
                  <p class="prominent">
                    @if (cash_movement.price > 0) {
                      <span>{{supported_currency.sign}}{{cash_movement.price | number:'1.2'}}</span>
                    }
                    @if (cash_movement.price < 0) {
                      <span>–{{supported_currency.sign}}{{(cash_movement.price * -1) | number:'1.2'}}</span>
                    }
                  </p>
                </ion-col>
              </ion-row>
              @if (cash_movement.note) {
                <ion-row>
                  <ion-col size="auto">
                    <h5>Note</h5>
                    <p class="ion-text-wrap prominent">{{cash_movement.note}}</p>
                  </ion-col>
                </ion-row>
              }
            </ion-grid>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  }

  @if (cash_movements && cash_movements.length == 0) {
    <ion-grid class="nothing-found">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <p>
            <fa-icon [icon]="['fal', 'magnifying-glass-dollar']" size="6x"></fa-icon>
            <span>No cash movements</span>
          </p>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>